
import { Vue, Component, Emit } from 'vue-property-decorator';

@Component
export default class DropdownItem extends Vue {
	@Emit('select')
	selectOption(): void {
		this.$emit('select', this.$slots.default?.[0].text);
	}
}
